var render = function render(){var _vm=this,_c=_vm._self._c;return (!(_vm.value === null || _vm.value === ''))?_c('Badge',{attrs:{"status":_vm.color,"text":_vm.text}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }